/* Arbove — Badge vidéo : lazy-load + play/pause via IntersectionObserver.
   - preload="none" : la vidéo n'est téléchargée qu'à l'entrée dans le viewport.
   - Pause dès la sortie du viewport -> jamais plusieurs vidéos qui tournent inutilement.
   - prefers-reduced-motion : on ne charge/joue rien (le CSS affiche l'image fixe). */
(function () {
  if (window.__arvbInit) return;
  window.__arvbInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(video) {
    if (!video.dataset.arvbLoaded) {
      try { video.load(); } catch (e) {}
      video.dataset.arvbLoaded = '1';
    }
    var p = video.play();
    if (p && p.catch) { p.catch(function () {}); }
  }

  function init() {
    var badges = document.querySelectorAll('.arvb[data-arvb]');
    if (!badges.length) return;

    // Reduced motion : on ne joue aucune vidéo (fallback image géré en CSS)
    if (reduce) return;

    if (!('IntersectionObserver' in window)) {
      // Vieux navigateurs : on laisse le poster/l'image, pas d'autoplay agressif
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video.arvb__video');
        if (!video) return;
        if (entry.isIntersecting) {
          play(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

    badges.forEach(function (badge) {
      if (badge.querySelector('video.arvb__video')) io.observe(badge);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
